import { useState, useEffect, useRef, useContext } from "react";
import datastore from '../store/hoa-datastore';
import { GlobalContext } from '../context/hoa-global-context';

let scrollTop:any = 0;

const useInfiniteScroll = (ref: any, fetchResult: any, tagType: string, numberOfProjects: number) => {
  const { muncipality, updateMuncipalityData, property, updatePropertyData, hoa, updateHoaData, mail, updateMailData, email, updateEmailData, document, updateDocumentData, requests, updateRequestsData, triggerNotifications, updateTriggerNotificationData, dataFieldConfigurator, updateDataFieldConfigurator, triggerNotificationLogs, updateTriggerNotificationLogsData, pendingSource, updatePendingSource } = useContext<any>(GlobalContext)

  const [isFetching, setIsFetching] = useState(false);
  const [rows, setRows] = useState(
    tagType === "Municipality" ? muncipality.data :
    tagType === "Property" ? property.data :
    tagType === "Hoa" ? hoa.data :
    tagType === "Mail" ? mail.data :
    tagType === "Email" ? email.data :
    tagType === "Document" ? document.data :
    tagType === "Requests" ? requests.data :
    tagType === "Webhook" ? triggerNotifications.data :
    tagType === "TriggerNotificationLog" ? triggerNotificationLogs.data :
    tagType === "DataFieldConfigurator" ? dataFieldConfigurator.data :
    tagType === "PendingSource" ? pendingSource.data :
    []);
  const [page, setPage] = useState(
    tagType === "Municipality" ? muncipality.pageNumber :
    tagType === "Property" ? property.pageNumber :
    tagType === "Hoa" ? hoa.pageNumber :
    tagType === "Mail" ? mail.pageNumber :
    tagType === "Email" ? email.pageNumber :
    tagType === "Document" ? document.pageNumber :
    tagType === "Requests" ? requests.pageNumber :
    tagType === "Webhook" ? triggerNotifications.pageNumber :
    tagType === "TriggerNotificationLog" ? triggerNotificationLogs.pageNumber :
    tagType === "DataFieldConfigurator" ? dataFieldConfigurator.pageNumber :
    tagType === "PendingSource" ? pendingSource.pageNumber :
    1);
    const [count, setCount] = useState(
      tagType === "Municipality" ? muncipality.count :
      tagType === "Property" ? property.count :
      tagType === "Hoa" ? hoa.count :
      tagType === "Mail" ? mail.count :
      tagType === "Email" ? email.count :
      tagType === "Document" ? document.count :
      tagType === "Requests" ? requests.count :
      tagType === "Webhook" ? triggerNotifications.count :
      tagType === "TriggerNotificationLog" ? triggerNotificationLogs.count :
      tagType === "DataFieldConfigurator" ? dataFieldConfigurator.count :
      tagType === "PendingSource" ? pendingSource.count :
      null);

  useEffect(()=>{
    /* first time data fetch */
    if(rows.length === 0) {
      setIsFetching(true);
    }
  },[])

  useEffect(()=>{
    if(tagType === 'Mail') {
      setRows(mail.data);
    }
  },[mail.data])

  useEffect(() => {
    const instance = ref.current;
    instance.addEventListener("scroll", ()=>{
      if (scrollTop !== instance.scrollTop) {
          scrollTop = instance.scrollTop;
          return isScrolling()
      }
    });
    return () => instance.removeEventListener("scroll", isScrolling);
  }, []);

  useEffect(() => {
    /* hoa filtering option trigger */
   if(tagType !== 'Hoa') return;

   if(hoa.fetchingFilteredData){
     setIsFetching(true);
   }
   setRows(hoa.data)
   setPage(hoa.pageNumber)
   setCount(hoa.count)
   datastore.lastPageStatus[tagType] = hoa.isLastPage;

 }, [hoa.fetchingFilteredData])

  useEffect(() => {
     /* muncipality filtering option trigger */
    if(tagType !== 'Municipality') return;

    if(muncipality.fetchingFilteredData){
      setIsFetching(true);
    }
    setRows(muncipality.data)
    setPage(muncipality.pageNumber)
    setCount(muncipality.count)
    datastore.lastPageStatus[tagType] = muncipality.isLastPage;

  }, [muncipality.fetchingFilteredData])

  useEffect(() => {
    /* Property filtering option trigger */
    if(tagType !== 'Property') return;

   if(property.fetchingFilteredData){
     setIsFetching(true);
   }

   setRows(property.data)
   setPage(property.pageNumber)
   setCount(property.count)
   datastore.lastPageStatus[tagType] = property.isLastPage;

 }, [property.fetchingFilteredData])

  useEffect(() => {
    /* Mail filtering option trigger */
    if(tagType !== 'Mail') return;

    if(mail.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(mail.data)
    setPage(mail.pageNumber)
    setCount(mail.count)
    datastore.lastPageStatus[tagType] = mail.isLastPage;
    
  }, [mail.fetchingFilteredData])

  useEffect(() => {
    /* Email filtering option trigger */
    if(tagType !== 'Email') return;

    if(email.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(email.data)
    setPage(email.pageNumber)
    setCount(email.count)
    datastore.lastPageStatus[tagType] = email.isLastPage;
    
  }, [email.fetchingFilteredData])

  useEffect(() => {
    /* Document filtering option trigger */
    if(tagType !== 'Document') return;

    if(document.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(document.data)
    setPage(document.pageNumber)
    setCount(document.count)
    datastore.lastPageStatus[tagType] = document.isLastPage;
  }, [document.fetchingFilteredData])

  useEffect(() => {
    /* Requests filtering option trigger */
    if(tagType !== 'Requests') return;

    if(requests.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(requests.data)
    setPage(requests.pageNumber)
    setCount(requests.count)
    datastore.lastPageStatus[tagType] = requests.isLastPage;
  }, [requests.fetchingFilteredData])

  useEffect(() => {
    /* Webhook filtering option trigger */
    if(tagType !== 'Webhook') return;

    if(triggerNotifications.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(triggerNotifications.data)
    setPage(triggerNotifications.pageNumber)
    setCount(triggerNotifications.count)
    datastore.lastPageStatus[tagType] = triggerNotifications.isLastPage;
  }, [triggerNotifications.fetchingFilteredData])

  useEffect(() => {
    /* Trigger notification log filtering option trigger */
    if(tagType !== 'TriggerNotificationLog') return;

    if(triggerNotificationLogs.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(triggerNotificationLogs.data)
    setPage(triggerNotificationLogs.pageNumber)
    setCount(triggerNotificationLogs.count)
    datastore.lastPageStatus[tagType] = triggerNotificationLogs.isLastPage;
  }, [triggerNotificationLogs.fetchingFilteredData]);

  useEffect(() => {
    /* Pending Source filtering option trigger */
    if(tagType !== 'PendingSource') return;

    if(pendingSource.fetchingFilteredData){
      setIsFetching(true);
    }

    setRows(pendingSource.data)
    setPage(pendingSource.pageNumber)
    setCount(pendingSource.count)
    datastore.lastPageStatus[tagType] = pendingSource.isLastPage;
  }, [pendingSource.fetchingFilteredData]);

  const callFunction = async () => {
    /* Call Api here */
    const response = await fetchResult(numberOfProjects, page);
    const totalCount = response.count;
    const inactiveHoaCount = response.inactiveHoaCount;
    if (response.data.length > 0) {

      const allData = [...rows, ...response.data];
      const pageNo = page + 1;
      setRows(allData);
      setPage(pageNo)
      setCount(response.count)
      setIsFetching(false)
      updateData(allData,pageNo,false, totalCount, inactiveHoaCount);
    }
    else if (response.data.length === 0) {

      datastore.lastPageStatus[tagType] = true;
      setIsFetching(false);
      updateData(rows,page,true, totalCount);
    }

  }

  const updateData = (data:any,page:any,isLastPage:boolean, totalCount: number, inactiveHoaCount?: any) => {

    if(tagType === 'Municipality') {
      updateMuncipalityData({
        ...muncipality,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
    });
    } else if (tagType === 'Property') {
      updatePropertyData({
        ...property,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
    });
    } else if (tagType === 'Hoa') {
      updateHoaData({
        ...hoa,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
        inactiveHoaCount: inactiveHoaCount
    });
    } else if (tagType === 'Mail') {
      updateMailData({
        ...mail,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
    });
    } else if (tagType === 'Email') {
      updateEmailData({
        ...email,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
    });
    } else if (tagType === 'Document') {
      updateDocumentData({
        ...document,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
      });
    } else if (tagType === 'Requests') {
      updateRequestsData({
        ...requests,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
      });
    }
    else if (tagType === 'Webhook') {
      updateTriggerNotificationData({
        ...triggerNotifications,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
      });
    }
    else if (tagType === 'TriggerNotificationLog') {
      updateTriggerNotificationLogsData({
        ...triggerNotificationLogs,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
      });
    }
    else if (tagType === 'DataFieldConfigurator') {
      updateDataFieldConfigurator({
        ...dataFieldConfigurator,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
      });
    }
    else if (tagType === 'PendingSource') {
      updatePendingSource({
        ...pendingSource,
        data: data,
        count: totalCount,
        pageNumber: page,
        isLastPage: isLastPage,
        fetchingFilteredData: false,
      });
    }
  }

  useEffect(() => {
    if (!isFetching) return;
    callFunction();
  }, [isFetching]);

  const isScrolling = () => {
    const { scrollTop, clientHeight, scrollHeight } = ref.current;
    if (scrollTop + clientHeight + 33 >= scrollHeight && !datastore.lastPageStatus[tagType] && !isFetching) {
      setIsFetching(true);
      return;
    }
  }

  return { isFetching, rows, count };
};

export default useInfiniteScroll;